<template>
  <CRow>
    <CCol col="12" md="12">
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <CCardBody>
                  <CInput
                    label="Symbol"
                    placeholder="Enter your Symbol name"
                    v-model="token.symbol"
                  />
                  <CInput
                    label="Name"
                    placeholder="Enter token  name"
                    v-model="token.name"
                  />

                  <CInput
                    label="Ethereum Address"
                    placeholder="Enter ethereum Address"
                    v-model="token.ethAddress"
                    autocomplete="off"
                  />
                  <CInput
                    label="Private key"
                    placeholder="Enter Private key"
                    v-model="token.privatekey"
                  />
                  <CInput
                    label="Contract Address"
                    placeholder="Enter contract address"
                    v-model="token.conAddress"
                  />

                  <CInput
                    label="Company twitter id"
                    placeholder="Enter twitter id"
                    v-model="token.twitterId"
                  />

                  <CInput
                    label="Company linkedin id"
                    placeholder="Enter linkedin id"
                    v-model="token.linkedID"
                  />
                  <CInput
                    type="number"
                    label="Userlimit"
                    placeholder="Enter User Limit"
                    v-model="token.Userlimit"
                  />
                  <CInput
                    type="number"
                    label="coinLimit"
                    placeholder="Enter User coinLimit"
                    v-model="token.coinLimit"
                  />
                  <CCol sm="12" style="padding-right: 0px; padding-left: 0px">
                    <CCard>
                      <CCardHeader>
                        <span style="font-size: 14px; font-weight: bold"
                          >Enable Daily Limit</span
                        >

                        <input
                          type="checkbox"
                          value="test"
                          v-model="dailylimit"
                          style="float: right; width: 113px; height: 22px"
                        />
                      </CCardHeader>
                      <CCardBody v-if="dailylimithide">
                        <CInput
                          placeholder="Enter daily limit"
                          type="number"
                          v-model="token.dailyLimit"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                  <CCol sm="12" style="padding-right: 0px; padding-left: 0px">
                    <CCard>
                      <CCardHeader>
                        <span style="font-size: 14px; font-weight: bold"
                          >Enable Max limit</span
                        >

                        <input
                          type="checkbox"
                          value="test"
                          v-model="maxlimit"
                          style="float: right; width: 113px; height: 22px"
                        />
                      </CCardHeader>
                      <CCardBody v-if="maxlimithide">
                        <CInput
                          placeholder="Enter max limit"
                          type="number"
                          v-model="token.maxLimit"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                  <CCol sm="12" style="padding-right: 0px; padding-left: 0px">
                    <CCard>
                      <CCardHeader>
                        <span style="font-size: 14px; font-weight: bold"
                          >NFT</span
                        >

                        <input
                          type="checkbox"
                          value="test"
                          v-model="isNft"
                          style="float: right; width: 113px; height: 22px"
                        />
                      </CCardHeader>
                      <CCardBody v-if="nftimage">
                        <CRow>
                          <CCol sm="9">
                            <label>NFT Image</label>
                            <div>
                              <div>
                                <input
                                  type="file"
                                  @change="previewImage7"
                                  accept="image*"
                                />
                              </div>
                              <div>
                                <p>
                                  Progress: {{ uploadValue7.toFixed() + "%" }}
                                  <progress
                                    id="progress"
                                    :value="uploadValue7"
                                    max="100"
                                  ></progress>
                                </p>
                                <CButton
                                  color="success"
                                  @click="onUpload7()"
                                  v-if="uploadbtn7"
                                  >Upload</CButton
                                >
                              </div>
                            </div>
                          </CCol>
                          <CCol sm="3">
                            <div v-if="imageData7 != null">
                              <img
                                class="preview"
                                :src="picture7"
                                style="
                                  width: 145px;
                                  height: 100px;
                                  float: right;
                                "
                              />
                              <br />
                            </div>
                            <br />
                            <br />
                          </CCol>
                        </CRow>

                        <CRow>
                          <CCol sm="9">
                            <label>NFT Audio</label>
                            <div>
                              <div>
                                <input
                                  type="file"
                                  @change="previewImage8"
                                  accept="image*"
                                />
                              </div>
                              <div>
                                <p>
                                  Progress: {{ uploadValue8.toFixed() + "%" }}
                                  <progress
                                    id="progress"
                                    :value="uploadValue8"
                                    max="100"
                                  ></progress>
                                </p>
                                <CButton
                                  color="success"
                                  @click="onUpload8()"
                                  v-if="uploadbtn8"
                                  >Upload</CButton
                                >
                              </div>
                            </div>
                          </CCol>
                          <CCol sm="12">
                            <div v-if="imageData8 != null">
                              <vue-audio :file="picture8"></vue-audio>

                              <br />
                            </div>
                            <br />
                            <br />
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                  </CCol>
                  <CCol sm="12" style="padding-right: 0px; padding-left: 0px">
                    <CCard>
                      <CCardHeader>
                        <span style="font-size: 14px; font-weight: bold"
                          >Random Location</span
                        >

                        <input
                          type="checkbox"
                          value="test"
                          v-model="token.isRandomLocation"
                          style="float: right; width: 113px; height: 22px"
                        />
                      </CCardHeader>
                    </CCard>
                  </CCol>

                  <CCol sm="12" style="padding-right: 0px; padding-left: 0px">
                    <CCard>
                      <CCardHeader>
                        <span style="font-size: 14px; font-weight: bold"
                          >IsBalance</span
                        >

                        <input
                          type="checkbox"
                          value="test"
                          v-model="token.isBalance"
                          style="float: right; width: 113px; height: 22px"
                        />
                      </CCardHeader>
                    </CCard>
                  </CCol>
                  <CInput
                    label="Network"
                    placeholder="Enter network"
                    v-model="token.network"
                  />
                </CCardBody>
              </CCol>

              <CCol sm="6">
                <br />
                <CInput
                  label="Company"
                  placeholder="Enter Company  name"
                  v-model="token.CompanyName"
                />
                <CRow>
                  <CCol sm="9">
                    <label>Company logo</label>
                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage"
                          accept="image/*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue"
                            max="100"
                          ></progress>
                        </p>

                        <CButton
                          color="success"
                          @click="onUpload()"
                          v-if="uploadbtn"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData != null">
                      <img
                        class="preview"
                        :src="picture"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol sm="9">
                    <label>Company display logo</label>

                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage2"
                          accept="image/*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue2.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue2"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload2()"
                          v-if="uploadbtn2"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData2 != null">
                      <img
                        class="preview"
                        :src="picture2"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol sm="9">
                    <label>Company capture logo</label>

                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage3"
                          accept="image*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue3.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue3"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload3()"
                          v-if="uploadbtn3"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData3 != null">
                      <img
                        class="preview"
                        :src="picture3"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol sm="9">
                    <label>Company 3D logo</label>
                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage4"
                          accept="image*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue4.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue4"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload4()"
                          v-if="uploadbtn4"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData4 != null">
                      <img
                        class="preview"
                        :src="picture4"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                    <br />
                    <br />
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol sm="9">
                    <label>Popup logo</label>
                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage5"
                          accept="image*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue5.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue5"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload5()"
                          v-if="uploadbtn5"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData5 != null">
                      <img
                        class="preview"
                        :src="picture5"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                    <br />
                    <br />
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol sm="9">
                    <label>Network logo</label>
                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage6"
                          accept="image*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue6.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue6"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload6()"
                          v-if="uploadbtn6"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData6 != null">
                      <img
                        class="preview"
                        :src="picture6"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                    <br />
                    <br />
                  </CCol>
                </CRow>
                <br />
                <CTextarea
                  label="Description"
                  placeholder="Content..."
                  horizontal
                  rows="4"
                  v-model="token.description"
                />
                <br />
                <CInput
                  type="number"
                  label="Token Rage(radius)"
                  placeholder="Enter token rage"
                  v-model="token.tokenrage"
                />

                <CInput
                  type="number"
                  label="Token Limit(show max)"
                  placeholder="Enter token limit"
                  v-model="token.tokenlimit"
                />
                <CInput
                  type="number"
                  label="Token Quantity"
                  placeholder="Enter token quantity"
                  v-model="token.coinQty"
                />

                <CInput
                  type="number"
                  label="Min Distance"
                  placeholder="Enter Min-Distance"
                  v-model.number="token.minDistance"
                />

                <CInput
                  type="number"
                  label="Token Refresh Rate (eg:15)"
                  placeholder="Enter tokenRefreshRate"
                  v-model.number="token.tokenRefreshRate"
                />
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol sm="8">
                <CInput
                  label="Token privatekey"
                  placeholder="Enter privatekey"
                  v-model="token.privatekey"
                />
              </CCol>
              <CCol sm="4"
                ><br />
                <CButton @click="tokenencrypt()" color="success">add</CButton>
              </CCol>
            </CRow> -->
          </CCol>
        </CRow>
      </CCardBody>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import VueAudio from "vue-audio";
var CryptoJS = require("crypto-js");

const db = firebase.firestore();
export default {
  components: { CTableWrapper, VueAudio },

  data() {
    return {
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,
      imageData2: null,
      picture2: null,
      uploadValue2: 0,
      uploadbtn2: false,
      imageData3: null,
      picture3: null,
      uploadValue3: 0,
      uploadbtn3: false,
      imageData4: null,
      picture4: null,
      uploadValue4: 0,
      uploadbtn4: false,

      imageData5: null,
      picture5: null,
      uploadValue5: 0,
      uploadbtn5: false,

      imageData6: null,
      picture6: null,
      uploadValue6: 0,
      uploadbtn6: false,

      imageData7: null,
      picture7: null,
      uploadValue7: 0,
      uploadbtn7: false,

      imageData8: null,
      picture8: null,
      uploadValue8: 0,
      uploadbtn8: false,

      dailylimithide: false,
      dailylimit: false,
      maxlimithide: false,
      maxlimit: false,
      upload: false,
      imgget: true,
      imgpre: false,
      imgpre2: false,
      imgget2: true,
      imgpre3: false,
      imgget3: true,
      imgpre4: false,
      imgget4: true,
      isNft: false,
      token: {
        isBalance: false,
        isCoinLimit: false,
        isRandomLocation: false,
        tokenRefreshRate: 0,
        minDistance: 0,
        tokenrage: "",
        symbol: "",
        name: "",
        CompanyName: "",
        description: "",
        logo: "",
        displaylogo: "",
        capturelogo: "",
        threelogo: "",
        popuplogo: "",
        networkimage: "",
        ethAddress: "",
        conAddress: "",
        privatekey: "",
        availableSupply: "",
        linkedID: "",
        twitterId: "",
        tokenlimit: "",
        network: "",
        Userlimit: 0,
        coinLimit: 0,
        coinQty: 0,
        isCoinLimit: false,
        ismaxLimit: false,
        isNft: false,
        dailyLimit: 0,
        maxLimit: 0,
        nftimage: false,
        nftImageurl: "",
        nftAudio: "",
      },

      imageTypes: ["image/jpeg", "image/png", "image/jpg"],
      imageUploaded: false,
      speciesCode: null,
      speciesName: "",
      speciesItem: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      multipleFileImages: "",
      imageFileDisp: null,
      logoimg: "",
      displayimg: "",
      captureimg: "",
      threeimg: "",
      cryptobject: "",
      decryptobject: "",
    };
  },
  // beforeDestroy() {
  //   this.nextTab();
  // },
  watch: {
    "token.isRandomLocation"() {
      if (this.token.isRandomLocation == true) {
        this.token.isRandomLocation = true;
      } else if (this.token.isRandomLocation == false) {
        this.token.isRandomLocation = false;
      }
    },
    "token.logo"() {
      this.upload = true;
    },
    dailylimit() {
      if (this.dailylimit == true) {
        this.dailylimithide = true;
        this.token.isCoinLimit = true;
      } else if (this.dailylimit == false) {
        this.dailylimithide = false;
        this.token.isCoinLimit = false;
      }
    },
    maxlimit() {
      if (this.maxlimit == true) {
        this.maxlimithide = true;
        this.token.ismaxLimit = true;
      } else if (this.maxlimit == false) {
        this.maxlimithide = false;
        this.token.ismaxLimit = false;
      }
    },
    isNft() {
      if (this.isNft == true) {
        console.log("this.isNft", this.isNft);
        this.token.isNft = true;
        this.nftimage = true;
      } else if (this.isNft == false) {
        console.log("this.isNft", this.isNft);
        this.token.isNft = false;
        this.nftimage = false;
      }
    },
  },
  methods: {
    validate() {
      //  this.$root.$emit("pass1", this.token);
      // this.$root.$emit("passdone", this.token);
      // return true;
      if (this.token.symbol == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter symbol",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.tokenrage == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter tokenrage",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.name == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter name",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.CompanyName == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter CompanyName",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.description == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter description",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.logo == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please choose logo",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.displaylogo == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please choose displaylogo",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.capturelogo == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please choose capturelogo",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.ethAddress == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter ethAddress",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.conAddress == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter contact address",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.privatekey == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter privatekey",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.linkedID == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter linkedID",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.twitterId == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter twitterId",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.tokenlimit == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter tokenlimit",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.Userlimit == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter Userlimit",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.coinLimit == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter coinLimit",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.dailyLimit == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter coinLimit",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.maxLimit == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter coinLimit",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        this.$root.$emit("passdone", this.token);
        return true;
      }
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url1", url);
            this.picture = url;
            this.token.logo = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    previewImage2(event) {
      this.uploadValue2 = 0;
      this.picture2 = null;
      this.imageData2 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn2 = true;
      // }
    },

    onUpload2() {
      this.picture2 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData2.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData2);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue2 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue2 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url2", url);
            this.picture2 = url;
            this.token.displaylogo = url;
            if (this.picture2.length > 0) {
              this.uploadbtn2 = false;
            }
          });
        }
      );
    },
    previewImage3(event) {
      this.uploadValue3 = 0;
      this.picture3 = null;
      this.imageData3 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn3 = true;
      // }
    },

    onUpload3() {
      this.picture3 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData3.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData3);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue3 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue3 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url3", url);
            this.picture3 = url;
            this.token.capturelogo = url;
            if (this.picture3.length > 0) {
              this.uploadbtn3 = false;
            }
          });
        }
      );
    },
    previewImage4(event) {
      this.uploadValue4 = 0;
      this.picture4 = null;
      this.imageData4 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn4 = true;
      // }
    },

    onUpload4() {
      this.picture4 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData4.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData4);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue4 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue4 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url4", url);
            this.picture4 = url;
            this.token.threelogo = url;
            if (this.picture4.length > 0) {
              this.uploadbtn4 = false;
            }
          });
        }
      );
    },

    previewImage5(event) {
      this.uploadValue5 = 0;
      this.picture5 = null;
      this.imageData5 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn5 = true;
      // }
    },

    onUpload5() {
      this.picture5 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData5.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData5);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue5 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue5 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url4", url);
            this.picture5 = url;
            this.token.popuplogo = url;
            if (this.picture5.length > 0) {
              this.uploadbtn5 = false;
            }
          });
        }
      );
    },

    previewImage6(event) {
      this.uploadValue6 = 0;
      this.picture6 = null;
      this.imageData6 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn6 = true;
      // }
    },

    onUpload6() {
      this.picture6 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData6.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData6);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue6 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue6 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url6", url);
            this.picture6 = url;
            this.token.networkimage = url;
            if (this.picture6.length > 0) {
              this.uploadbtn6 = false;
            }
          });
        }
      );
    },

    previewImage8(event) {
      this.uploadValue8 = 0;
      this.picture8 = null;
      this.imageData8 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn8 = true;
      // }
    },

    onUpload8() {
      this.picture8 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData8.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData8);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue8 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue8 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url8", url);
            this.picture8 = url;
            this.token.nftAudio = url;
            if (this.picture8.length > 0) {
              this.uploadbtn8 = false;
            }
          });
        }
      );
    },
    previewImage7(event) {
      this.uploadValue7 = 0;
      this.picture7 = null;
      this.imageData7 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn7 = true;
      // }
    },

    onUpload7() {
      this.picture7 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData7.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData7);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue7 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue7 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url7", url);
            this.picture7 = url;
            this.token.nftImageurl = url;
            if (this.picture7.length > 0) {
              this.uploadbtn7 = false;
            }
          });
        }
      );
    },
    tokenencrypt() {
      // console.log("this.token.privatekey", password);
      this.cryptobject = CryptoJS.AES.encrypt(
        this.token.privatekey,
        password
      ).toString();

      this.dencrypt();
    },
    dencrypt() {
      var password = "2020+SmartChat/Encrypt@";
      // console.log("encrypt", this.cryptobject);
      this.decryptobject = CryptoJS.AES.decrypt(
        this.cryptobject,
        password
      ).toString(CryptoJS.enc.Utf8);
      // console.log("decrypt", this.decryptobject);
    },

    nextTab() {
      this.$emit("pass1", this.token);
    },

    wizard() {
      this.$router.push({ name: "wizard" });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.speciesCode = item.speciesCode;
      this.speciesName = item.speciesName;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
  },
  created() {
    // this.getSpeciesList();
    // this.getserviceList();
  },
};
</script>
<style scoped>
tbody > tr > :nth-child(1) {
  color: red;
  width: 200px;
  text-align: center;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: inset;
}
</style>
